import React from 'react';
import cx from 'classnames';
import { nextIconName, prevIconName } from '../../helpers/arrowIconIdentifier';
import styles from './GalleryArrow.scss';

const GalleryArrow = (properties) => {
  const { isShown = true, className, position, isMobile, globalClassName, navClass } = properties;
  const handleClick = (evt) => {
    evt.stopPropagation();
    if (properties.handleClick) {
      properties.handleClick();
    }
  };

  return (
    (isShown) ? (
      <div
        className={cx(styles.arrowWrapper, styles[className], styles[`${position}Arrow`], globalClassName, navClass)}
        title={properties.title}
        onClick={handleClick}
      >
        <i className={`icon icon-${(position === 'left') ? prevIconName(isMobile) : nextIconName(isMobile)}`} />
      </div>
    ) : (<div />)
  );
};

export default GalleryArrow;
